import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  facts: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  pill: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "x18g2hj5",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x13s4r1c",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    color: "xtt1gjl",
    $$css: true
  },
  bgAge: {
    backgroundColor: "x15xno7f",
    $$css: true
  },
  bgGender: {
    backgroundColor: "xs3zovl",
    $$css: true
  },
  bgRelationship: {
    backgroundColor: "xhhksk5",
    $$css: true
  },
  iconAge: {
    color: "x1gonuu0",
    $$css: true
  },
  iconGender: {
    color: "x18yk8ih",
    $$css: true
  },
  iconRelationship: {
    color: "x178yly6",
    $$css: true
  }
};